import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconAddPullRequest: FC<BaseIconProps> = ({ className, ...props }) => {
    return (
        <svg
            className={className}
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="1.66667"
                cy="1.66667"
                r="1.66667"
                transform="matrix(1 0 0 -1 2.6665 13.6667)"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle
                cx="1.66667"
                cy="1.66667"
                r="1.66667"
                transform="matrix(1 0 0 -1 2.6665 5.66675)"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M4.3335 10.3333V5.66659" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M11.6665 7V5.665C11.6665 4.56043 10.7711 3.665 9.66655 3.665H8.5"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6665 13.5V9.25736M13.7878 11.3787H9.54518"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
